const basePaymentsApiPath = 'organizations/:organizationId/fundings';

export const fundingsApiPaths = {
    funding: `${basePaymentsApiPath}/:fundingId`,
} as const;
